export default __webpack_public_path__ + "static/media/project3.d53ade87.png";